import React from 'react'
import Image from 'components/image/image'
import './block-comparison-table.sass'

const ComparisonHeader = ({ comparers }) => (
  <div className="ComparisonHeader">
    <div className="empty"></div>
    {comparers.map(el => (
      <div>
        <h4>{el}</h4>
      </div>
    ))}
  </div>
)

const ComarisonListRow = ({ row, row_odd }) => (
  <React.Fragment>
    <div className={row_odd ? 'filled' : null}>
      <p><b>{row.title}</b></p>
    </div>
    {row.points.map((content, i) => {

      let has_check = false;
      if (content.includes('✓')) {
        content = content.replace('✓','');
        has_check = true;
      }

      return (
        <div className={row_odd ? 'filled' : ''} key={i}>
          {has_check ? <Image image_url="icons/icon-comparison-check.svg" className="ComarisonListRow__check mr-3 float-left"/> : null}

          <p dangerouslySetInnerHTML={{ __html: content}}/>
        </div>
        )
      }

    )}
  </React.Fragment>
)

const ComarisonList = ({ list }) => (
  <div className="ComarisonListRow">
    {list.map((row, i) =>  <ComarisonListRow row={row} key={i} row_odd={i % 2 === 0} /> )}
  </div>
)
const BlockComparisonTable = ({ data }) => {
  const { comparers, list} = data.comparision_table;

  return (
    <section className="BlockComparisonTable container-fluid container-fluid--small">
      <ComparisonHeader comparers={comparers}/>
      <ComarisonList list={list}/>
    </section>
  )
}

export default BlockComparisonTable
